<div class="position-relative">
    @if (!form()) {
        <kno2-loading-spinner />
    }
    <div class="row mx-0">
        <div
            class="col-sm-3 px-0"
            style="margin-top: -1px">
            <div class="inbox">
                <div class="col-sm-12 user-menu">
                    <ul class="event-type-list">
                        <li
                            class="title alerts-title"
                            style="cursor: default">
                            Profile Options
                        </li>
                        @if (user()) {
                            <li
                                [class.alerts-menu-active]="currentTab() === 'editProfile'"
                                (click)="currentTab.set('editProfile')">
                                Edit Profile
                            </li>
                            @if (user()?.organizations.length) {
                                <li
                                    [class.alerts-menu-active]="currentTab() === 'emailNotifications'"
                                    (click)="currentTab.set('emailNotifications')">
                                    Email Notifications
                                </li>
                            }
                            <li
                                [class.alerts-menu-active]="currentTab() === 'userPreferences'"
                                (click)="currentTab.set('userPreferences')">
                                User Preferences
                            </li>
                            @if (user()?.authorizedApps?.length) {
                                <li
                                    [class.alerts-menu-active]="currentTab() === 'authorizedApplications'"
                                    (click)="currentTab.set('authorizedApplications')">
                                    My Applications
                                </li>
                            }
                            @if (user()?.externalLoginTokens?.length || hasCacheIntegrationData()) {
                                <li
                                    [class.alerts-menu-active]="currentTab() === 'integrations'"
                                    (click)="currentTab.set('integrations')">
                                    Integrations
                                </li>
                            }
                        }
                    </ul>
                </div>
            </div>
        </div>
        <div class="modal-body col-sm-9 mt-4">
            @if (error()) {
                <kno2-notification-alert
                    type="danger"
                    [title]="error()"
                    (dismiss)="error.set(null)"></kno2-notification-alert>
            }
            @if (form()) {
                <kno2-profile-edit
                    [hidden]="currentTab() !== 'editProfile'"
                    [parentForm]="form()"
                    [mfaRequired]="mfaRequired()"
                    [changingPassword]="changingPassword()" />
                <kno2-profile-email-notifications
                    [hidden]="currentTab() !== 'emailNotifications'"
                    [preferencesForm]="form().get('userPreferences')"
                    [isAdministrator]="user().isAdministrator" />
                <kno2-profile-user-preferences
                    [hidden]="currentTab() !== 'userPreferences'"
                    [preferencesForm]="form().get('userPreferences')" />
                <kno2-profile-authorized-applications
                    [hidden]="currentTab() !== 'authorizedApplications'"
                    [userId]="user().id"
                    [authorizedApps]="user().authorizedApps"
                    (onRemoveApp)="loadUser()" />
                <kno2-profile-integrations
                    [hidden]="currentTab() !== 'integrations'"
                    [externalLoginTokens]="user().externalLoginTokens"
                    (onRevokeToken)="loadUser()" />
            }
        </div>
    </div>

    <div class="modal-footer mt-0">
        <button
            type="button"
            class="btn btn-default"
            (click)="cancel()">
            Cancel
        </button>
        <button
            id="SaveChanges"
            class="btn btn-primary"
            data-style="zoom-in"
            (click)="save()"
            [disabled]="isSubmitting()">
            @if (isSubmitting()) {
                <span class="spinner-border spinner-border-sm"></span>
            }
            Save Changes
        </button>
    </div>
</div>
